module.exports = __webpack_public_path__ + "static/media/deri-staff-web-hubton.e1ef3e73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/deri-staff-web-hubton.png
// module id = 185
// module chunks = 0